<template>
    <v-container>
        <span v-if="!dataloading">
            <v-row>
            <v-col cols="12" sm="3">
                <ChooseOfWheels v-model="wheels" source="change"/>
            </v-col>
            <v-col cols="12" sm="9">
                <v-card flat>
                    <v-tabs
                            v-model="tab"
                    >
                        <v-tab
                                v-for="item in tabs"
                                :key="item.key"
                                @click="isFirstTab = false"
                        >
                            <v-img :src="icon[item.icon]" aspect-ratio="2" contain class="tabs_icons"></v-img>
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item
                                v-for="item in tabs"
                                :key="item.key"
                        >
                            <v-card flat class="main_bg_color">
                                <wheelRadius :side="item.key" :typeselected="type"/>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="9" class="result-text" v-if="getTotalWheelsInfo(showActive)">
                <p v-for="(item,index) in getTotalWheelsInfo(showActive)" :key="index">
                    [{{ item.item.side }}] {{ item.text }}
                </p>
            </v-col>
            <v-col cols="12" sm="3" class="pt-0" v-if="totalPriceFull">
                <div class="price mb-3">
                                            <span class="fullprice" v-if="discount>0">
                                                {{numberWithSpaces(totalPriceFull)}} ₽
                                            </span>
                    <span class="discount" v-if="discount>0">
                                                -{{ discount }}%
                                            </span>
                    <span class="discountprice">
                                                {{numberWithSpaces(totalPrice)}} ₽
                                            </span>
                </div>
                <v-btn large color="#C8FA92" @click="addServiceToCart" block>
                    Добавить
                </v-btn>
            </v-col>
        </v-row>
        </span>
    </v-container>
</template>

<script>
    // @ is an alias to /src
    import ChooseOfWheels from './ChooseOfWheels'
    import wheelRadius from './tireChange/wheelRadius'

    export default {
        props: ['type', 'itemID'],
        components: {
            ChooseOfWheels,
            wheelRadius,
        },
        computed: {
            icon () {
                return this.$store.state.imgs.icon
            },
            changeLoding () {
                return this.$store.state.change.loading
            },
            title () {
                return this.$store.state.change.ChangePrice[this.type].title
            },
            discount () {
                return 0 //(this.$store.state.clientIdentify.client.discount.value + this.$store.state.clientIdentify.client.additional_discount.value) * 100
            },
            showActive () {
                let active = []
                const wheelsName = [ 'forwardLeft', 'forwardRight', 'backLeft', 'backRight', 'spareLeft', 'spareRight' ]
                const wheelsNameRus = [ 'Переднее левое', 'Переднее правое', 'Заднее левое', 'Заднее правое', 'Запасное левое', 'Запасное правое' ]
                wheelsName.forEach((key,index) => {
                    if (this.$store.state.change.wheels[key][this.type] && this.$store.state.change.wheels[key][this.type].isActive) {
                        active.push({name: wheelsNameRus[index], data: this.$store.state.change.wheels[key][this.type]})
                    }
                })
                return active
            },
            tabs() {
                let res = [];
                const icons = ['fl', 'fr', 'bl', 'br', 'sl', 'sr'];
                let i = 0;
                for (const key in this.wheels) {
                    if (this.wheels[key]) {
                        res.push({key: key, icon: icons[i], slot: icons[i]})
                    }
                    i++;
                }
                return res
            },
            QRcodeUrl() {
                return this.$store.state.repair.QRcodeUrl
            },
            tireName() {
                return this.$store.state.change.tireName
            },
            isFirstTab: {
                get() {
                    return this.$store.state.change.isFirstTab[this.type]
                },
                set(value) {
                    this.$store.commit('change/setIsFirstTab', { type: this.type, value })
                }
            },
            wheels: {
                get() {
                    return {
                        forwardLeft: this.$store.state.change.wheels.forwardLeft[this.type].isActive,
                        forwardRight: this.$store.state.change.wheels.forwardRight[this.type].isActive,
                        backLeft: this.$store.state.change.wheels.backLeft[this.type].isActive,
                        backRight: this.$store.state.change.wheels.backRight[this.type].isActive,
                        spareLeft: this.$store.state.change.wheels.spareLeft[this.type].isActive,
                        spareRight: this.$store.state.change.wheels.spareRight[this.type].isActive
                    }
                },
                set(value) {
                    console.log(value)
                    this.$store.dispatch('change/changeActiveWheels', {type:this.type, sides:value})
                }
            },
            availableTire () {
                return this.$store.state.change['availableTire']
            },
            tireList (){
                return this.$store.state.change.tireName
            },

        },
        data() {
            return {
                allValues: [],
                dataloading: true,
                showInfo:false,
                totalPrice: null,
                totalPriceFull: null,
                timeToSet:  null,
                resultText: '',
                tab: 0,
                panel: 0,
                myInputModel: '',
                dropped: true,
            }
        },
        methods: {
            async addServiceToCart () {
                let service = this.$store.getters.services[this.itemID]
                for (let i=0; i < this.allValues.length; i++) {
                    const x = this.allValues[i]
                    await this.$store.dispatch('addServiceToCart', {
                        'id': x.options.id,
                        'service': service,
                        'client': this.$store.getters.client ,
                        'quantity': x.item.quantity,
                        'description': '[' + x.item.side + ']' + x.text,
                        'params': {
                            diskType: x.item.solidDisk?'Литой диск':'Штампованый диск',
                            diskR: 'R' + x.item.radius,
                            carType: x.item.carType,
                            wheelSide: x.item.name,
                            isRunflat: x.item.isRunflat,
                            frameVehicle: x.item.isFrameVehicle,
                            text: '[' + x.item.side + ']' + x.text,
                            content: x
                        },
                        'price': x.price
                    })
                }
            },
            numberWithSpaces(x) {
                if(x){
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                }
            },
            infoClick(){
                this.showInfo = !this.showInfo
            },
            getTotalWheelsInfo (value) {
                if(!this.dataloading){
                    let allValues = []
                    const tireName = [0,12,13,14,15,16,17,18,19,20,21,22,23,24] //название шин строкой так как приходит в калькулятор строка а в прайсах id
                    const cdiscont = this.discount
                    let totalPrice = 0
                    let totalDiscount = 0
                    let timeToSet = 0
                    let getPriceOptions = null
                    if(this.$store.state.change.ChangePrice[this.type])
                    {
                        getPriceOptions = this.$store.state.change.ChangePrice[this.type].services
                    }
                    value.forEach((x) => {
                        let name = x.name
                        x = x.data.data
                        x.side = this.shortSidename(name)
                        x.name = name
                        let radtext = ' R' + x.radius +''
                        let text = radtext + ' '
                        let price = 0
                        let discont = 0
                        let wheelPriceOptions = {}
                        if(getPriceOptions){
                            wheelPriceOptions = getPriceOptions.findIndex(v => {
                               return v.car_type_id == x.carType && tireName[v.wheel_diameter_id] == x.radius
                            } )
                          console.log('wheelPriceOptions',getPriceOptions[wheelPriceOptions])
                          if(getPriceOptions[wheelPriceOptions]){

                                price = price + parseInt(getPriceOptions[wheelPriceOptions].price)
                              if (getPriceOptions[wheelPriceOptions].runflat_affects===1 && x.isRunflat && getPriceOptions[wheelPriceOptions].runflat_additional_price && getPriceOptions[wheelPriceOptions].additional_price) {
                                  price = price + parseInt(getPriceOptions[wheelPriceOptions].additional_price, 10)
                                }
                                if (!x.isRunflat && getPriceOptions[wheelPriceOptions].frame_vehicle_affects===1 && x.isFrameVehicle && getPriceOptions[wheelPriceOptions].frame_vehicle_additional_price) {
                                    price = price + parseInt(getPriceOptions[wheelPriceOptions].additional_price, 10)
                                }
                                if(cdiscont > parseInt(getPriceOptions[wheelPriceOptions].maximum_discount)){
                                    discont = discont + Math.floor(price / 100 * parseInt(getPriceOptions[wheelPriceOptions].maximum_discount))
                                } else {
                                    discont = discont + Math.floor(price / 100 * cdiscont)
                                }
                                text = text + getPriceOptions[wheelPriceOptions].description
                            }

                        }
                        totalPrice = totalPrice + price
                        totalDiscount = totalDiscount + discont
                        if (price===0) { text='' }
                        const i = allValues.findIndex(val => val.text == text)
                        if (i >= 0) {
                            x.side = allValues[i].item.side + "," + x.side
                            x.quantity = allValues[i].item.quantity + 1
                            allValues.splice(i, 1, {
                                text,
                                item: x,
                                price: allValues[i].price,
                                options:getPriceOptions[wheelPriceOptions]
                            });
                        } else {
                            x.quantity = 1
                            allValues.push({ text, item: x, price: price, options:getPriceOptions[wheelPriceOptions] })
                        }
                        // if ( text !== '') {
                        //     const valueToAdd = { text, price, item: x , options:getPriceOptions[wheelPriceOptions]}
                        //     allValues.push(valueToAdd)
                        // }
                    })
                    this.timeToSet = timeToSet
                    this.totalPrice = Math.round((totalPrice - totalDiscount))
                    this.totalPriceFull = Math.round(totalPrice)
                    this.$store.commit('updateServicesPrice', [this.itemID ,this.totalPriceFull])
                    this.allValues = allValues
                    return allValues
                } else {
                    return [{ text: 0, price: 0 }]
                }
            },
            shortSidename(sideName) {
                const wheelsName = ["ПЛ", "ПП", "ЗЛ", "ЗП", "ЗАП1", "ЗАП2"];
                const wheelsNameRus = [
                    "Переднее левое",
                    "Переднее правое",
                    "Заднее левое",
                    "Заднее правое",
                    "Запасное левое",
                    "Запасное правое"
                ];
                let index = wheelsNameRus.findIndex(x => x == sideName);
                return wheelsName[index];
            },

        },
        mounted() {
            console.log('init',this.type)
            this.dataloading = true
            this.$store.dispatch('change/init', this.type)
            this.isFirstTab = true
            this.dataloading = false
        }
    }
</script>
